import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

//services
import { HttpService } from './common/http.service';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private httpServiceInstance: HttpService;

  constructor(
    private httpService: HttpService,
    private _environmentService: EnvironmentService
  ) {
    this.httpServiceInstance = this.httpService.createInstance({
      baseUrl: `${this._environmentService.getFacilityConfig().facilityUrl}api/v${this._environmentService.getFacilityConfig().facilityApiVersion}`
    });
  }

  /**
   * Subscribe an email to the mailing list
   * @param email The email address to subscribe
   * @returns Observable of the API response
   */
  subscribe(email: string): Observable<any> {
    const payload = { email };
    return this.httpServiceInstance.post('Marketing/Campaign/Subscribe', payload);
  }

  /**
   * Unsubscribe an email from the mailing list
   * @param email The email address to unsubscribe
   * @returns Observable of the API response
   */
  unsubscribe(email: string): Observable<any> {
    const payload = { email };
    return this.httpServiceInstance.post('Marketing/Campaign/Unsubscribe', payload);
  }
}
